















import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'Login',
})
export default class Login extends Vue {
    public error: string = '';
    public updating: boolean = false;

    public async mounted() {
        this.updating = true;
        await this.$store.dispatch('account/logout');
        this.updating = false;
        this.$router.replace('/');
    }
}
